var _module_exports = "<section id=\"help\" class=\"rg-Wrapper\">\n  <div class=\"container\">\n    <div class=\"fq-HelpWrap panel-group\">\n      <h2 class=\"text-center\">Frequently Asked Questions</h2>\n      <section ng-bind-html=\"support\"></section>\n    </div>\n  </div>\n</section>\n";;
var path = '/containers/core/views/support.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/containers/core/views/support.html
// module id = 698
// module chunks = 0